import React, { FC, useState, useEffect, useMemo } from 'react'
import { View, KeyboardAvoidingView, useWindowDimensions, Pressable, Platform, BackHandler } from 'react-native'
import { useIsFocused } from '@react-navigation/native';
import { ThemeConsumer } from "@rneui/themed";
import { useFormik } from 'formik';
import * as yup from 'yup'
import moment from 'moment';
import Toast from "react-native-toast-message";
import Popover from 'react-native-popover-view/dist/Popover';

import { config } from '../../../shared/environment';
import { API } from "../../../shared/apiRoutes";
import { appColors, fontSize } from '../../../themes/appTheme'

// Common component
import CommonHeader from '../../../shared/commonComponents/commonHeader'
import CommonDialogBox from '../../../shared/commonComponents/commonDialogBox';

import { AxiosError } from 'axios';
import { getScreenPermission, useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { useAppNavigation, useAppRoute } from '../../../types/@react-navigation/navigation';
import { getAllDiscountTypesForPos, getPosPropertyCode, getOneDiscount, updatedAutomatic, createAutomatic, getCustomerEligibilityTypeData, } from '../../../redux/slices/automaticDiscountSlice';
import { discountRes, discType, restrictionValueType, customerEligibility, discount, updateValType, discRestriction, RestrictionData, DropDownData, } from './addEditAutomaticDiscountModule';

import { ZenText, ZenButton, ZenLoader, ZenInput, ZenDropdown, ZenCheckBox, ZenRadioButton, ZenIcon, ZenDateTimePicker, ZenToolTip, ZenToast } from 'zen-core-elements';
import { ScrollView } from 'react-native-gesture-handler';
import { CustomModal } from '../../../shared/commonComponents/customModal';
import { confirmtionMessageProps } from '../manualDiscount/manualDiscountModule';
import { shallowEqual } from 'react-redux';
import { PayXGetFreeStyle } from '../../../themes/components/discounts/payXGetFreeStyle';

type eligibleCustomerDataType = Map<string, { value: { label: string; value: string | number; id: number; }[], name: string, code: string }>

const AddEditAutomaticDiscount: FC = () => {
    const { isLandscape } = useAppSelector((state) => state.common)
    const { isWrite } = useAppSelector(getScreenPermission("AutomaticDiscountStack"), shallowEqual);

    // redux dispatch
    const dispatch = useAppDispatch()
    // Variable which is used to render styles based on device dimention
    const { width } = useWindowDimensions()
    // Variable which is used for navigation
    const navigation = useAppNavigation()
    // Variable used to store Focused state
    const isFocused = useIsFocused()
    // Variable which is used to store route values
    const { params } = useAppRoute("AddEditAutomaticDiscount")
    // Variable to hold property values
    const [discountType, setDiscountType] = useState<discType[] | any>([])
    // Variable which is used to hold discount applies to
    const [appliesTo, setAppliesTo] = useState<restrictionValueType[] | any>([])
    // Variable which is used to store the discount data
    const [discountValue, setDiscountValue] = useState<discountRes>()
    // Variable which is used to hold load state
    const [load, setLoad] = useState<boolean>(false)
    // Variable which is used to store selected discount type
    const [selectDiscountType, setSelectDiscountType] = useState<number>();
    // Variable which is used to store customer eligibility type
    const [typesOfEligibility, setTypesOfEligibility] = useState<customerEligibility[] | any>([]);
    // Variable which is used to store restriction value
    const [restriction, setRestriction] = useState<discRestriction[]>([])
    // Variable which is used to show warning popover
    const [warningPopover, setWarningPopover] = useState<string | null>('')
    //variable is used to open/close the expired warning popover
    const [expiredPopover, setExpiredPopover] = useState<boolean>(false)
    // Variable which is used to open/close model state
    const [failedToLoadingProps, setFailedToLoadingProps] = useState<boolean>(false)
    //variable to open/clode dropDown
    const [dropdownOpen, setDropdownOpen] = useState<boolean>(false)
    //variable to set hold the current date
    const [mydate, setDate] = useState(new Date());
    // Variable which is used for check end date expired or not
    const [endDateExpired, setEndDateExpired] = useState<boolean>(false)
    // Variable used to show the availability of discount
    const [isDiscountAvailable, setIsDiscountAvailable] = useState<boolean>(true)
    //variable used to open/close date picker
    const [showDate, setShowDate] = useState<boolean>(false);
    //Variable to set startDate
    const [startDateSelected, setStartDateSelected] = useState<boolean>(false)
    // Variable which is used to open/close eligibility dropdown picker 
    const [eligibilityOpen, setEligibilityOpen] = useState<boolean>(false)
    // Variable which is used to open/close customergroup picker
    const [customerGroupOpen, setCustomerGroupOpen] = useState<boolean>(false)
    //Variablt to open/close specific option 
    const [specificOptionOpen, setSpecificOptionOpen] = useState<boolean>(false)
    // Variable to store the eligibility data as a object array
    const [eligibileCustomersArr, setEligibileCustomersArr] = useState<eligibleCustomerDataType>(new Map())
    // Variable to store the discount applicable option's data as a object array
    const [applicableDiscountArr, setApplicableDiscountArr] = useState<eligibleCustomerDataType>(new Map())
    //variable to store the warning confirmation msg
    const [isOptionChanged, setIsOptionChanged] = useState<boolean>(false)


    //variable to display the warning message for end date expired
    const expiredDialogProps = {
        content: 'The discount has expired; kindly change the "End date" to further edit the discount.',
        button: [{ id: 1, name: 'Okay', color: appColors.primary, backgroundColor: appColors.light }],
        icon: { name: 'alert-outline', size: 55, color: appColors.warning, type: 'material-community' }
    }

    //variable used to store leave page dialogbox props
    const leaveDialogProps = {
        content: 'Are you sure you want to leave this page? ',
        button: [{ id: 1, name: 'No', color: appColors.primary, backgroundColor: appColors.light }, { id: 2, name: 'Yes', color: appColors.light, backgroundColor: appColors.primary }],
        icon: { name: 'run', color: appColors.primary, type: 'material-community' }
    }

    //variable to display the warning message for product/category does't load
    const failedProps = {
        content: "Unfortunately, some products/categories/brands have been removed from their respective pages, so they are not loaded in applies to item.",
        button: [{ id: 1, name: 'Okay', color: appColors.primary, backgroundColor: appColors.light }],
        icon: { name: 'close-circle-outline', color: appColors.warning, type: 'material-community' }
    }

    // UseEffect hook used to make corresponding api call while page is focused
    useEffect(() => {
        if (isFocused) {
            setLoad(true)
            getDiscountTypes()
        }
    }, [isFocused])


    //useEffect which gets triggered when discount expires
    useEffect(() => {
        if (endDateExpired) {
            setExpiredPopover(true)
        }
    }, [endDateExpired])

    const getDiscountTypes = async () => {
        await dispatch(getAllDiscountTypesForPos({ storeId: config?.storeId })).unwrap().then(async (res) => {
            if (res && res?.discountTypes) {
                setDiscountType(res?.discountTypes?.map((ele: discount) => ({ ...ele, value: ele.id, label: ele.discountName, code: ele.code })));
                setSelectDiscountType(res?.discountTypes?.find((i: discount) => i?.code === 'PERCENTAGE')?.id)
            }
            getOnePosDiscount()
        }).catch((err) => console.log('Error in getDiscountTypes', err))
    }

    // Method which is used to get discount type, property values and discount data
    const getOnePosDiscount = async () => {
        const property = ["RECCURRENCE", "APPLICABLE_CUSTOMERS", "APPLICABLE_ITEMS", "APPLICABLE_TO", "DISCOUNT_RESTRICTION_VALUES", "DISCOUNT_CONDITIONAL_TYPE"]
        await dispatch(getPosPropertyCode({ storeId: config?.storeId, propertyValue: property })).unwrap().then(async (propertyRes) => {
            if (propertyRes) {
                let discRestrictionArr: RestrictionData[] = [];
                propertyRes?.propertyValueData.map((item) => {
                    item.code === "DISCOUNT_RESTRICTION_VALUES" && item.propertyValues?.map((resVal) => {
                        discRestrictionArr.push({ id: resVal?.id, label: resVal?.value, value: resVal?.value, code: resVal?.code })
                        setRestriction(discRestrictionArr)
                    })
                    if (item.code === "APPLICABLE_CUSTOMERS") {
                        let applicableCustomers: DropDownData[] = []
                        let customerData: eligibleCustomerDataType = new Map()
                        item?.propertyValues?.map((val) => {
                            if (!customerData?.has(val?.id?.toString()) && val?.value !== "For All") {
                                customerData.set(val.id?.toString(), { value: [], name: val?.value === "Customer Type" ? "Roles" : val?.value, code: val?.code })
                            }
                            applicableCustomers.push({ code: val?.code, label: val?.value === "Customer Type" ? "Roles" : val?.value, value: val?.id.toString(), id: val?.id })
                        })
                        setTypesOfEligibility(applicableCustomers)
                        setEligibileCustomersArr(customerData)

                    }
                    if (item?.code === "APPLICABLE_TO") {
                        let applicableDiscountsData: eligibleCustomerDataType = new Map()
                        let discountData: DropDownData[] = []
                        item?.propertyValues?.map((values) => {
                            if (!applicableDiscountsData?.has(values?.id?.toString()) && values?.code !== "ORDER") {
                                applicableDiscountsData.set(values?.id?.toString(), { value: [], name: values?.value, code: values?.label })
                                discountData.push({
                                    id: values?.id,
                                    label: values?.value,
                                    value: values?.id.toString(),
                                    code: values?.code
                                })
                                setAppliesTo(discountData);
                            }
                        })
                        setApplicableDiscountArr(applicableDiscountsData)
                    }
                })
                if (params?.id) {//if edit id exists
                    getOneAutomaticDiscount()
                }
                !params?.id && setLoad(false)
            }
        }).catch((Error: AxiosError) => {
            console.log("Error in get property code999", Error)
        })
    }

    //function to fetch single Discount details
    const getOneAutomaticDiscount = () => {
        setLoad(true);
        let props = { storeId: config?.storeId, discountId: params?.id!! }
        dispatch(getOneDiscount(props))?.unwrap()?.then((res) => {
            if (res && res?.discount) {
                setDiscountValue(res?.discount);
                if (res?.discount?.title === null) {
                    setIsDiscountAvailable(false)
                }
            }
            if (res?.discount?.endDate != null) {
                if (moment(res?.discount?.endDate).endOf('day').toDate() < moment(new Date()).endOf('day').toDate()) {
                    setEndDateExpired(true)
                }
            }
        }).catch((err) => {
            console.log('Error in getOneDiscount', err)
        }).finally(() => {
            setTimeout(() => { setLoad(false) }, 2000)
        })
    }

    // method to perform the validation
    const validationSchema = yup.object().shape({
        discountTitle: yup.string()
            .label('Discount title')
            .max(20, "Discount title should not exceed 50 characters")
            .required('Discount title is required.'),
        discountType: yup.number()
            .label('Discount Type')
            .required('Discount Type is required'),
        discountValue: yup.number()
            .when("discountType", (discountTypeId) => {
                if (discountType?.find((i: discType) => i?.id == discountTypeId[0])?.code == 'PERCENTAGE') {
                    return yup.number()
                        .label('Discount Value')
                        .required("Discount value is required")
                        .typeError('Discount value accepts only numbers')
                        .integer("Discount value accepts only whole numbers")
                        .min(1, "Discount value should be starts from 1")
                        .max(100, "Discount value should not exceed 100")
                }
                else {
                    return yup.number()
                        .label('Discount Value')
                        .required("Discount value is required")
                        .typeError('Discount value accepts only numbers')
                        .min(1, "Discount value should be starts from 1")
                        .max(10000, "Discount value should not exceed 10000")
                        .test('2 decimals only', 'Discount value accepts upto 2 decimals only', (val) =>
                            val < 10000 ? /^\d+(\.\d{1, 2})?$/.test(val.toString()) : true,
                        )
                }
            }),
        maximumDiscountValue: yup.number()
            .label('maximumDiscountValue')
            .nullable()
            .typeError('Maximum discount value accepts only numbers')
            .min(0.01, "Maximum discount value should be starts from 0.01")
            .max(10000, "Maximum discount value should not exceed 10000")
            .test('2 decimals only', 'Maximum discount value accepts up to 2 decimals only', (val) =>
                val ? /^\d+(\.\d{1, 2})?$/.test(val.toString()) : true,
            ),
        description: yup.string().label('description').max(250, 'Description should not exceed 250 characters'),
        discountRestriction: yup.string(),
        restrictionValue: yup.number().label('restrictionValue').when("discountRestriction", (discountRes: any, schema: any) => {
            return schema.when(() => {
                if (discountRes) {
                    if (restriction?.find((i: restrictionValueType) => i?.value == discountRes)?.code === 'MINIMUM_PURCHASE_AMOUNT') {
                        return yup.number()
                            .typeError('Provide valid restriction value')
                            .min(0.01, 'Restriction value should start from 0.01')
                            .max(1000000, 'Restriction value should not exceed 10,00,000')
                            .test('2 decimals only', 'Restriction value accepts up to 2 decimals only', (val) => val ? /^\d+(\.\d{1,2})?$/.test(val.toString()) : true)
                            .when("discountType", (discountTypeValue) => {
                                if (discountType.find((i: discType) => i.id == discountTypeValue[0])?.code === 'FIXED') {
                                    return yup.number()
                                        .required("Restriction value is required")
                                        .typeError('Provide valid restriction value')
                                        .min(0.01, 'Restriction value should start from 0.01')
                                        .test('2 decimals only', 'Restriction value accepts up to 2 decimals only', (val) => val ? /^\d+(\.\d{1,2})?$/.test(val.toString()) : true)
                                        .when("discountValue", (discountValue: any) => {
                                            return yup.number()
                                                .required("Restriction value is required")
                                                .typeError('Provide valid restriction value')
                                                .min(discountValue, 'Restriction value should not be less than the discount value')
                                                .max(1000000, 'Restriction value should not exceed 10,00,000')
                                                .integer('Restriction value accepts only whole numbers');
                                        })
                                        .max(1000000, 'Restriction value should not exceed 10,00,000');
                                } else {
                                    return yup.number()
                                        .required("Restriction value is required")
                                        .typeError('Provide valid restriction value')
                                        .min(0.01, 'Restriction value should start from 0.01')
                                        .max(1000000, 'Restriction value should not exceed 10,00,000')
                                        .test('2 decimals only', 'Restriction value accepts up to 2 decimals only', (val) => val ? /^\d+(\.\d{1,2})?$/.test(val.toString()) : true);
                                }
                            });
                    } else if (restriction?.find((i: restrictionValueType) => i?.value == discountRes)?.code === 'MINIMUM_QUANTITY_OF_ITEMS') {
                        return yup.number()
                            .required("Restriction value is required")
                            .typeError('Provide valid restriction value')
                            .min(1, 'Restriction value should start from 1')
                            .max(1000, 'Restriction value should not exceed 1000')
                            .integer('Restriction value accepts only whole numbers')
                            .test('2 decimals only', 'Restriction value accepts up to 2 decimals only', (val) => val ? /^\d+(\.\d{1,2})?$/.test(val.toString()) : true);
                    }
                    else {
                        return yup.mixed().notRequired().nullable()
                    }
                }
            });
        }),
        TotalUsagelimits: yup.number().label('usagelimits')
            .nullable()
            .max(1000, 'Total usage limits should not exceed 1000')
            .min(1, "Total usage limit should range from 1 to 1000")
            .integer("Total usage limits accepts only whole numbers .")
            .typeError('Total usage limits accepts only numbers.'),
        Usagelimitpercustomer: yup.number().label('Usagelimitpercustomer').when('TotalUsagelimits', (limitVal: number[]) => {
            if (limitVal[0]) {
                return yup.number().integer('Usage limits per customer accepts only whole numbers.')
                    .typeError('Usage limits per customer only accept numbers')
                    .min(1, "Usage limits per customer should start from 1")
                    .max(1000, 'Usage limits per customer should not exceed 1000.')
                    .test('checking', 'Usage limits per customer should not exceed the total usage limit.', (val?: number) => {
                        if (val === undefined) return true;
                        return val < 1000 ? limitVal[0] >= val : true;
                    });
            } else {
                return yup.number().label('usagelimitpercustomer')
                    .integer('Usage limits per customer accepts only whole numbers.')
                    .typeError('Usage limits per customer only accept numbers')
                    .min(1, "Usage limits per customer should start from 1")
                    .max(1000, "Usage limits per customer should not exceed 1000.");
            }
        }),
        startDate: yup.date()
            .label('startDate'),
        endDate: yup.date()
            .nullable() // Allows endDate to be null or undefined
            .when("startDate", (startDate, schema) => {
                return startDate
                    ? schema.test(
                        "date-comparison",
                        "End date is greater than startDate",
                        (val) => !val || moment(val).isSameOrAfter(moment(startDate[0]))
                    )
                    : schema;
            }),
        discountAppliesTo: yup.string(),
        specific: yup.array().label('specific')
            .when("discountAppliesTo", (discount) => {
                let applicableOption = applicableDiscountArr.get(discount[0])?.name
                if (applicableOption == 'Specific  Products' || applicableOption == 'Specific  Categories' || applicableOption == 'Specific Brands') {
                    return yup.array().required(`${applicableOption} is required`).min(1, `Minimum 1 ${applicableOption} is required`)
                }
                else {
                    return yup.array()
                }
            }),
        customerEligibilityType: yup.string(),
        eligibility: yup.array().label('eligibility')
            .when("customerEligibilityType", (eligibleType: string[]) => {
                let customerType = eligibileCustomersArr.get(eligibleType[0])?.name
                if (customerType === "Customer Group" || customerType === "Customers" || customerType === "Customer Type") {
                    return yup.array()
                        .required('Customer Eligibility is required')
                        .min(1, 'Minimum 1 Customer Eligibility is required');
                }
                return yup.array().nullable();
            }),
    })

    // Variable which is used to access formik value
    const formik = useFormik({
        initialValues: {
            discountTitle: discountValue?.title ? String(discountValue?.title) : '',
            discountType: discountValue?.discountTypeId ? discountValue?.discountTypeId : discountType.find((i: discType) => i?.code == 'PERCENTAGE')?.value,
            discountValue: discountValue?.discountValue && parseFloat(discountValue?.discountValue) > 0 ? String(parseFloat(discountValue?.discountValue)) : '',
            maximumDiscountValue: discountValue?.maxAmount && parseFloat(discountValue?.maxAmount) > 0 ? String(parseFloat(discountValue?.maxAmount)) : '',
            description: discountValue?.description ? discountValue?.description : '',
            isActive: params?.id ? (discountValue?.isActive !== undefined ? discountValue?.isActive : true) : true,
            discountRestriction: params?.id ? discountValue?.restrictionBasedOn ? restriction?.find((val: discRestriction) => val?.id == discountValue?.restrictionBasedOn)?.value : restriction?.find((val: RestrictionData) => val?.code == "NONE")?.value : restriction?.find((val: RestrictionData) => val?.code == "NONE")?.value,
            restrictionValue: discountValue?.minValue && parseFloat(discountValue?.minValue) > 0 ? String(parseFloat(discountValue?.minValue)) : '',
            TotalUsagelimits: discountValue?.overallUsageLimit && parseFloat(discountValue?.overallUsageLimit) > 0 ? String(parseFloat(discountValue?.overallUsageLimit)) : '',
            Usagelimitpercustomer: params?.id ? discountValue?.userBasedMaxUse && parseFloat(discountValue?.userBasedMaxUse) > 0 ? String(parseFloat(discountValue?.userBasedMaxUse)) : '' : '',
            discountAppliesTo: params?.id ? appliesTo?.find((val: restrictionValueType) => val?.id == discountValue?.appliesTo)?.value : appliesTo?.find((val: restrictionValueType) => val?.code == "PRODUCT")?.value,
            startDate: params?.id ? (discountValue?.startDate != undefined ? discountValue?.startDate : '') : useMemo(() => new Date(), []),
            endDate: params?.id ? discountValue?.endDate ? discountValue?.endDate.toString() : '' : '',
            customerEligibilityType: params?.id ? discountValue?.customerEligibilityType ? typesOfEligibility?.find((val: customerEligibility) => val.id == discountValue?.customerEligibilityType)?.value : typesOfEligibility?.find((val: customerEligibility) => val.code === "FOR ALL")?.value : typesOfEligibility?.find((val: customerEligibility) => val.code == 'FOR_ALL')?.value,
            specific: params?.id ? getApplicableItems() : [],
            eligibility: params?.id ? getEligiblityData() : []
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values: updateValType) => {
            createOrUpdateDiscount(values)
        }
    });

    useEffect(() => {
        if (endDateExpired) {
            setExpiredPopover(true)
        }
    }, [endDateExpired])

    useEffect(() => {
        const backHandler = BackHandler.addEventListener('hardwareBackPress', () => {
            if (formik?.dirty) {
                setWarningPopover('leave')
                return true
            }
            else {
                navigation.goBack()
            }
            return true
        });
        return () => backHandler?.remove()
    }, [formik?.values])

    function getApplicableItems() {
        let data: any = []
        const brandDiscountMappings = discountValue?.discountMappings?.brandDiscountMappings;
        const categoryDiscountMappings = discountValue?.discountMappings?.categoryDiscountMappings;
        const productDiscountMappings = discountValue?.discountMappings?.productDiscountMappings;
        if (brandDiscountMappings?.length) {
            data = brandDiscountMappings
        }
        else if (categoryDiscountMappings?.length) {
            data = categoryDiscountMappings
        }
        else if (productDiscountMappings?.length) {
            data = productDiscountMappings
        }
        return data;
    }

    function getEligiblityData() {
        let data: any = []
        const roleDiscountMappings = discountValue?.discountMappings?.roleDiscountMappings;
        const customerGroupDiscountMappings = discountValue?.discountMappings?.customerGroupDiscountMappings;
        const customerDiscountMappings = discountValue?.discountMappings?.customerDiscountMappings;
        if (roleDiscountMappings?.length) {
            data = roleDiscountMappings
        }
        else if (customerGroupDiscountMappings?.length) {
            data = customerGroupDiscountMappings
        }
        else if (customerDiscountMappings?.length) {
            data = customerDiscountMappings
        }
        return data;
    }

    function getSpecificValue() {
        let data: any = []
        const brandDiscountMappings = discountValue?.discountMappings?.brandDiscountMappings;
        const categoryDiscountMappings = discountValue?.discountMappings?.categoryDiscountMappings;
        const productDiscountMappings = discountValue?.discountMappings?.productDiscountMappings;
        if (brandDiscountMappings?.length) {
            data = brandDiscountMappings
        }
        else if (categoryDiscountMappings?.length) {
            data = categoryDiscountMappings
        }
        else if (productDiscountMappings?.length) {
            data = productDiscountMappings
        }
        return data;
    }

    useEffect(() => {
        if (formik?.values?.customerEligibilityType && eligibileCustomersArr?.has(formik?.values?.customerEligibilityType)) {
            let apiVersion: "v1" | "v2" = "v2"
            let { code, value } = eligibileCustomersArr?.get(formik?.values?.customerEligibilityType)!!
            const data = { isDiscount: true, isActive: true, issueCard: true };
            if (!value?.length) {
                let url = API.eligibleCustomer;
                if (code === "ROLE_BASED") {
                    url = `stores/{storeId}/roles`
                } else if (code === "CUSTOMER_GROUP") {
                    url += "group";
                } else if (code === "CUSTOMERS") {
                    url += "name";
                }
                if (url) {
                    dispatch(getCustomerEligibilityTypeData({ storeId: config.storeId, url, data, apiVersion })).unwrap().then((res) => {
                        if (res) {
                            let response: { name?: string, groupName: string, id: number }[] = res?.customergroup?.rows || res?.roles?.rows || res?.customers || []
                            if (!response?.length) {
                                ZenToast({ message: `${code} is empty, Choose any other eligibility type`, type: "warning" })
                                formik.setFieldValue('customerEligibilityType', '');
                            }
                            const customersVal = response?.map((e) => ({ label: e?.name || e?.groupName, value: e?.id, id: e?.id }));
                            setEligibileCustomersArr((prev) => {
                                let data = prev
                                if (data?.has(formik?.values?.customerEligibilityType)) {
                                    let { code, name } = data.get(formik?.values?.customerEligibilityType)!!
                                    data.set(formik?.values?.customerEligibilityType, { code, name, value: [...customersVal] })
                                }
                                return new Map(data)
                            })
                        }
                    })
                }
            }
        }
    }, [formik?.values?.customerEligibilityType]);

    useEffect(() => {
        if (formik?.values?.discountAppliesTo && applicableDiscountArr?.has(formik?.values?.discountAppliesTo)) {
            let apiVersion: "v1" | "v2" = "v2"
            let { name, value } = applicableDiscountArr?.get(formik?.values?.discountAppliesTo)!!
            const data = { isDiscount: true }
            if (!value?.length) {
                let url = "stores/{storeId}/"
                if (name === 'Specific  Products') {
                    // apiVersion = "v1"
                    url += 'products/name';
                }
                else if (name === 'Specific  Categories') {
                    url += 'categories/name';
                }
                else if (name === 'Specific Brands') {
                    url += 'brands/name';
                }
                if (url) {
                    dispatch(getCustomerEligibilityTypeData({ storeId: config.storeId, url, data, apiVersion })).unwrap().then((res) => {
                        if (res) {
                            let response: { name: string, id: number }[] = res?.products?.rows || res?.category || res?.brand
                            const applicableOptionsVal = response?.map((e) => ({ label: e?.name, value: e?.id, id: e?.id }));
                            setApplicableDiscountArr((prev) => {
                                let data = prev
                                if (data?.has(formik?.values?.discountAppliesTo)) {
                                    let { code, name } = data.get(formik?.values?.discountAppliesTo)!!
                                    data.set(formik?.values?.discountAppliesTo, { code, name, value: [...applicableOptionsVal] })
                                }
                                return new Map(data)
                            })
                        }
                    })
                }
            }
        }
    }, [appliesTo, formik?.values?.discountAppliesTo])

    // Method which is used to handle confirmation message
    const confirmation = (value: { name: string }) => {
        if (value?.name == 'Yes' && warningPopover) {
            setWarningPopover('')
            navigation?.goBack()
        }
        if (value?.name == "Okay" && expiredPopover) {
            setExpiredPopover(false)
        }
        if (value?.name == "Okay" && failedToLoadingProps) {
            setFailedToLoadingProps(false)
        }
        else {
            setWarningPopover('')
        }
    }
    const checkAnyChanges = (val: any, currentData: any, eligiblitycode: string, discountName: string, discountItems: any) => {
        if (val?.customerEligibilityType !== discountValue?.customerEligibilityType?.toString()) {
            return true
        }
        else if (!eligiblitycode) {
            return true
        }
        else if (!discountName) {
            return true
        }
        else if (eligiblitycode) {
            let prevData: number[] = []
            if (eligiblitycode === "CUSTOMER_GROUP") {
                prevData = discountValue?.discountMappings?.customerGroupDiscountMappings ?? []
            } else if (eligiblitycode === "CUSTOMERS") {
                prevData = discountValue?.discountMappings?.customerDiscountMappings ?? []
            } else if (eligiblitycode === "ROLE_BASED") {
                prevData = discountValue?.discountMappings?.roleDiscountMappings ?? []
            }
            if (prevData?.length !== currentData?.length) {
                return true
            }
            else {
                let result = currentData?.every((item: any) => prevData.includes(item))
                return !result
            }
        }
        else {
            let prevData: number[] = []
            if (discountName === "Specific Brands") {
                prevData = discountValue?.discountMappings?.brandDiscountMappings ?? []
            } else if (discountName === "Specific  Categories") {
                prevData = discountValue?.discountMappings?.categoryDiscountMappings ?? []
            } else if (discountName === "Specific  Products") {
                prevData = discountValue?.discountMappings?.productDiscountMappings ?? []
            }
            if (prevData?.length !== currentData?.length) {
                return true
            }
            else {
                let result = discountItems?.every((item: any) => prevData.includes(item))
                return !result
            }
        }
    }

    // Method which is used to update and create automatic discount
    const createOrUpdateDiscount = (val: updateValType) => {
        let appliestoId = appliesTo?.find((value: restrictionValueType) => value?.value == val?.discountAppliesTo)
        let restrictionBasedOnId = restriction?.find((value: discRestriction) => value?.value === val?.discountRestriction)
        const eligiblitycode = eligibileCustomersArr?.get(val?.customerEligibilityType)?.code || ""
        const eligibilityValue = val.eligibility
        const discountName = applicableDiscountArr?.get(val?.discountAppliesTo)?.name || ""
        const discountItems = val?.specific
        const data = {
            isChangeEligibility: params?.id ? checkAnyChanges(val, eligibilityValue, eligiblitycode, discountName, discountItems) : true,
            isAppliesToChange: true,
            storeId: config?.storeId,
            isManual: false,
            title: val?.discountTitle ? String(val?.discountTitle) : null,
            minValue: val?.restrictionValue ? Number(val?.restrictionValue) : null,
            discountValue: Number(val?.discountValue),
            maxAmount: discountType?.find((item: discType) => item.id == selectDiscountType)?.code == 'FIXED' ? null : val?.maximumDiscountValue ? Number(val?.maximumDiscountValue) : null,
            discountTypeId: val?.discountType ? Number(val?.discountType) : null,
            overallUsageLimit: val?.TotalUsagelimits ? Number(val?.TotalUsagelimits) : null,
            userBasedMaxUse: val?.Usagelimitpercustomer ? Number(val?.Usagelimitpercustomer) : null,
            startDate: val?.startDate ? val?.startDate : moment(),
            endDate: val?.endDate ? val?.endDate : null,
            isActive: val?.isActive,
            description: val?.description ? val?.description : null,
            customerEligibilityType: Number(val?.customerEligibilityType),
            customerGroupDiscountMapping: eligiblitycode == "CUSTOMER_GROUP" ? eligibilityValue : null,
            customerDiscountMapping: eligiblitycode == "CUSTOMERS" ? eligibilityValue : null,
            roleDiscountMapping: eligiblitycode == "ROLE_BASED" ? eligibilityValue : null,
            appliesTo: appliestoId ? appliestoId?.id : null,
            restrictionBasedOn: restrictionBasedOnId ? restrictionBasedOnId?.id : null,
            isPos: true,
            medium: "POS",
            isWeb: false,
            toAll: eligiblitycode == "" ? true : false,
            brandDiscountMapping: discountName == "Specific Brands" ? discountItems : null,
            productDiscountMapping: discountName == "Specific  Products" ? discountItems : null,
            categoryDiscountMapping: discountName == "Specific  Categories" ? discountItems : null,
        }
        if (params?.id) {
            dispatch(updatedAutomatic({ storeId: config?.storeId, id: params?.id, data: data })).unwrap().then((res) => {
                if (res) {
                    Toast?.show({ type: "success", text1: "Success", text2: "Automatic discount updated successfully" })
                    setLoad(false);
                    navigation.goBack();
                }
            }).catch((Error: AxiosError) => {
                console.log('error in update automatic discount', Error)
            })
        }
        else {
            dispatch(createAutomatic({ storeId: config?.storeId, data: data })).unwrap().then((response) => {
                if (response && response?.discount) {
                    Toast?.show({ type: "success", text1: "Success", text2: "Automatic discount saved successfully" })
                    setLoad(false);
                    navigation.goBack()
                }
            }).catch((Error: AxiosError) => {
                console.log('error in create automatic discount', Error)
            })
        }
    }

    //method to perform the onConfirm functionality
    const onDateConfirm = (date: Date) => {
        if (startDateSelected) {
            formik.setFieldValue('startDate', moment(date))
        }
        else {
            formik?.setFieldValue('endDate', moment(date))
            setEndDateExpired(false);
        }
        setShowDate(false)
    }

    const getAllLabelValue = (dropdownVal: any, name: boolean) => {
        if (!dropdownVal?.length) {
            return ""
        }
        let arr = name
            ? eligibileCustomersArr.get(formik?.values?.customerEligibilityType)?.value
            : applicableDiscountArr.get(formik?.values?.discountAppliesTo)?.value;

        let result = dropdownVal.map((item: any) => {
            let currData = arr?.find((val) => val?.id === item);
            return currData?.label;
        });
        return result.join(",")
    }

    const showMaxDiscount = discountType.find((i: any) => i.value === formik?.values?.discountType)?.label === "Percentage";

    useEffect(() => {
        if (formik?.values?.discountRestriction) {
            formik?.setFieldTouched('restrictionValue', true);
            const restrictionId = (restriction?.find((i: RestrictionData) => i?.label === formik?.values?.discountRestriction))?.id
            if (discountValue?.restrictionBasedOn === restrictionId) {
                formik.setFieldValue('restrictionValue', String(parseFloat(discountValue?.minValue!!)));
            }
            else {
                formik.setFieldValue('restrictionValue', '');
            }
            setIsOptionChanged(false)
        }

    }, [formik?.values?.discountRestriction])
    useEffect(() => {
        if (formik?.values?.discountAppliesTo) {
            formik.setFieldTouched('specific', true);
            if (discountValue?.appliesTo === appliesTo.find((i: any) => i.value === formik?.values?.discountAppliesTo)?.id) {
                formik.setFieldValue('specific', getSpecificValue());
            } else {
                formik.setFieldValue('specific', []);
            }
            setIsOptionChanged(false)
        }
    }, [formik?.values?.discountAppliesTo])

    useEffect(() => {
        if (formik?.values?.customerEligibilityType) {
            formik.setFieldTouched('eligibility', true)
            if (discountValue?.customerEligibilityType.toString() === formik?.values?.customerEligibilityType) {
                formik.setFieldValue('eligibility', getEligiblityData())
            }
            else {
                formik.setFieldValue('eligibility', [])
            }
            setIsOptionChanged(false)
        }

    }, [formik?.values?.customerEligibilityType])

    return (
        <ThemeConsumer>
            {({ theme }) => (
                <KeyboardAvoidingView behavior={Platform.OS === 'ios' ? 'padding' : undefined} enabled style={theme?.automaticDiscountListStyle.container}>
                    <CommonHeader headerName={params?.id ? `${isWrite ? "Edit" : "View"} Automatic Discount` : 'Add Automatic Discount'} backIcon={true} backIconOnpress={() => { formik?.dirty ? setWarningPopover('leave') : navigation.goBack() }} />
                    <View style={{ flex: 1 }}>
                        <View style={{
                            flexDirection: "row", justifyContent: "space-between",
                            alignSelf: !isDiscountAvailable ? 'auto' : 'flex-end',
                        }}>
                            {!isDiscountAvailable && (
                                <View style={{ backgroundColor: '#FFE5E5', paddingHorizontal: 10, paddingVertical: 5, borderRadius: 6, margin: 10 }}>
                                    <ZenText content={"This discount is currently not available"} bold style={{ color: appColors?.red, marginVertical: 10, fontSize: fontSize.smallFontSize }} />
                                </View>
                            )}
                            <View style={theme?.automaticDiscountListStyle.buttonView}>

                                {isWrite && <ZenButton title={params?.id ? "Update" : "Save"}
                                    disabled={(!formik?.isValid || !formik?.dirty) || isOptionChanged || endDateExpired}
                                    disabledStyle={{ borderColor: 'transparent' }}
                                    onPress={formik?.handleSubmit}
                                    titleStyle={{ fontSize: fontSize.tinyFontSize, color: theme?.light }}
                                    buttonStyle={{
                                        backgroundColor: theme?.primary,
                                        borderRadius: 10,
                                        paddingHorizontal: 15,
                                        borderColor: 'transparent',
                                        borderWidth: 1
                                    }}
                                    containerStyle={{ borderRadius: 10, }}
                                />}
                            </View>

                        </View>


                        {load ?
                            < View style={{ flex: 1, alignItems: "center", justifyContent: "center", marginVertical: 240 }}>
                                <ZenLoader viewStyle={{ backgroundColor: "transparent" }} color={theme?.primary} lottieType="Local" lottie={require('../../../assets/infinityLoader.json')} />
                            </View> :
                            <ScrollView showsVerticalScrollIndicator={false}>
                                <View style={{ flex: 1, gap: 10, marginBottom: 10 }}>
                                    <View style={{ backgroundColor: theme?.light, marginHorizontal: 10, borderRadius: 10, paddingHorizontal: 10, }}>
                                        <ZenText content={"Basic Info"} style={theme?.automaticDiscountListStyle?.subHeading} />
                                        <View style={{ flexDirection: "row", flex: 1, gap: 25 }}>
                                            <ZenInput
                                                value={formik?.values?.discountTitle}
                                                onChangeText={(txt) => { formik.setFieldValue('discountTitle', txt) }}
                                                label={"Discount Title *"}
                                                labelStyle={theme?.automaticDiscountListStyle?.labelStyle}
                                                inputStyle={theme?.automaticDiscountListStyle?.inputStyle}
                                                disabled={(endDateExpired || params?.id || !isWrite) ? true : false}
                                                onBlur={() => { formik.setFieldTouched('discountTitle', true); formik.setFieldValue('discountTitle', formik?.values?.discountTitle?.trim()) }}
                                                type="outlined"
                                                containerStyle={{ flex: 1 }}
                                                inputContainerStyle={{ paddingHorizontal: 8, height: 45 }}
                                                errorMessage={formik.touched.discountTitle && formik.errors.discountTitle ? formik.errors.discountTitle : undefined}
                                                errorStyle={{ color: 'red', fontFamily: theme?.medium, fontSize: fontSize.errorFontSize }}
                                            />
                                            <View style={{ flexDirection: "column", flex: 1 }} >
                                                <ZenText content='Discount Type *' style={{ fontFamily: theme?.medium, fontSize: fontSize.tinyFontSize, color: theme?.grey }} />
                                                <ZenDropdown
                                                    items={discountType}
                                                    open={dropdownOpen}
                                                    setOpen={setDropdownOpen}
                                                    value={formik?.values?.discountType}
                                                    setValue={() => { }}
                                                    multiple={false}
                                                    dropdownDirection='BOTTOM'
                                                    disabled={endDateExpired || !isDiscountAvailable || !isWrite ? true : false}
                                                    labelStyle={{ fontSize: fontSize.tinyFontSize, color: endDateExpired || !isWrite ? theme?.grey : theme?.dark, fontFamily: theme?.medium, }}
                                                    placeholderStyle={{ color: theme?.grey, fontFamily: theme?.medium, fontSize: fontSize.tinyFontSize, }}
                                                    style={{ height: 46 }}
                                                    selectedItemLabelStyle={{ fontSize: fontSize.tinyFontSize, fontFamily: theme?.medium }}
                                                    containerStyle={{ marginTop: 5 }}
                                                    onPress={() => { formik?.setFieldTouched('discountType', true) }}
                                                    onSelectItem={(item) => {
                                                        formik?.setFieldValue('discountType', item?.value)
                                                    }}
                                                />
                                                {formik?.touched?.discountType && formik.errors.discountType ? formik.errors.discountType : undefined}
                                            </View>

                                        </View>
                                        <View style={{ flexDirection: "row", flex: 1, gap: 25 }}>
                                            <ZenInput
                                                value={formik?.values?.discountValue}
                                                disabled={endDateExpired || !isDiscountAvailable || !isWrite ? true : false}
                                                onChangeText={(txt) => { formik.setFieldValue('discountValue', txt) }}
                                                label={"Discount Value *"}
                                                labelStyle={theme?.automaticDiscountListStyle?.labelStyle}
                                                inputStyle={theme?.automaticDiscountListStyle?.inputStyle}
                                                keyboardType="numeric"
                                                type="outlined"
                                                containerStyle={{ flex: showMaxDiscount ? 0.5 : 0.49 }}
                                                inputContainerStyle={{ paddingHorizontal: 8, height: 45 }}
                                                onBlur={() => { formik.setFieldTouched('discountValue', true); formik.setFieldValue('discountValue', formik?.values?.discountValue?.trim()) }}
                                                errorMessage={formik.touched.discountValue && formik.errors.discountValue ? formik.errors.discountValue : undefined}
                                                errorStyle={{ color: 'red', fontFamily: theme?.medium, fontSize: fontSize.errorFontSize }}
                                            />
                                            {showMaxDiscount ?
                                                <ZenInput
                                                    disabled={endDateExpired || !isDiscountAvailable || !isWrite ? true : false}
                                                    value={formik?.values?.maximumDiscountValue}
                                                    onChangeText={(text) => formik.setFieldValue('maximumDiscountValue', text)}
                                                    label={params?.id ? "Max Discount Value" : "Maximum Discount Value"}
                                                    labelStyle={theme?.automaticDiscountListStyle?.labelStyle}
                                                    inputStyle={theme?.automaticDiscountListStyle?.inputStyle}
                                                    keyboardType="numeric"
                                                    type="outlined"
                                                    containerStyle={{ flex: 0.5 }}
                                                    inputContainerStyle={{ paddingHorizontal: 8, height: 45 }}
                                                    onBlur={() => { formik?.setFieldTouched('maximumDiscountValue', true); formik?.setFieldValue('maximumDiscountValue', formik?.values?.maximumDiscountValue?.trim()) }}
                                                    errorMessage={formik.touched.maximumDiscountValue && formik.errors.maximumDiscountValue ? formik.errors.maximumDiscountValue : undefined}
                                                    errorStyle={{ color: 'red', fontFamily: theme?.medium, fontSize: fontSize.errorFontSize }}
                                                /> : <></>}

                                        </View>
                                        <View style={{ flexDirection: "row", flex: 1, gap: 25 }}>
                                            <ZenInput
                                                value={formik?.values?.description}
                                                onChangeText={(text) => formik.setFieldValue('description', text)}
                                                label={"Description"}
                                                disabled={endDateExpired || !isDiscountAvailable || !isWrite ? true : false}
                                                labelStyle={theme?.automaticDiscountListStyle?.labelStyle}
                                                inputStyle={theme?.automaticDiscountListStyle?.inputStyle}
                                                type="outlined"
                                                containerStyle={{ flex: 1 }}
                                                inputContainerStyle={{ paddingHorizontal: 8, height: 45 }}
                                                onBlur={() => { formik.setFieldTouched('description', true); formik.setFieldValue('description', formik?.values?.description?.trim()) }}
                                                errorMessage={formik.touched.description && formik.errors.description ? formik.errors.description : undefined}
                                                errorStyle={{ color: 'red', fontFamily: theme?.medium, fontSize: fontSize.errorFontSize }}
                                            />
                                            <View style={{ flexDirection: !isLandscape ? "column" : "row", flex: 1, gap: !isLandscape ? 10 : 25, justifyContent: !isLandscape ? "center" : "flex-start", alignItems: "flex-start", }}>
                                                <ZenCheckBox
                                                    title={'Enable'}
                                                    checked={formik?.values?.isActive}
                                                    disabled={endDateExpired || !isWrite ? true : false}
                                                    size={isLandscape ? 22 : 15}
                                                    containerStyle={{ alignSelf: "center" }}
                                                    titleStyle={theme?.automaticDiscountListStyle.checkBoxText}
                                                    checkedColor={theme?.primary}
                                                    onPress={() => { formik?.setFieldValue('isActive', !formik?.values?.isActive) }}
                                                />

                                            </View>
                                        </View>
                                    </View>

                                    <View style={{ backgroundColor: theme?.light, marginHorizontal: 10, borderRadius: 10, paddingHorizontal: 10, }}>
                                        <ZenText content={"Discount Restriction"} style={theme?.automaticDiscountListStyle?.subHeading} />
                                        <View style={{ flexDirection: !isLandscape ? "column" : "row", flex: 1, gap: !isLandscape ? 10 : 25 }}>
                                            <ZenRadioButton
                                                initialSelected={formik?.values?.discountRestriction}
                                                options={restriction.map(opt => ({
                                                    ...opt,
                                                    disabled: endDateExpired || !isWrite || !isDiscountAvailable
                                                }))}
                                                titleStyle={{ color: theme?.lightDark, fontSize: fontSize?.largerFontSize }}
                                                containerStyle={{ flexDirection: "column", flex: 1, justifyContent: "space-between", flexWrap: "wrap" }}
                                                onSelect={(value) => {
                                                    setIsOptionChanged(true)
                                                    formik.setFieldValue('discountRestriction', value);
                                                }}

                                            />
                                            {((restriction?.find((i: RestrictionData) => i?.label === formik?.values?.discountRestriction))?.code != 'NONE') &&
                                                <ZenInput
                                                    value={formik?.values?.restrictionValue}
                                                    onChangeText={(txt) => { formik.setFieldValue('restrictionValue', txt) }}
                                                    label={"Restriction Value *"}
                                                    disabled={endDateExpired || !isDiscountAvailable || !isWrite ? true : false}
                                                    labelStyle={theme?.automaticDiscountListStyle?.labelStyle}
                                                    inputStyle={theme?.automaticDiscountListStyle?.inputStyle}
                                                    type="outlined"
                                                    containerStyle={{ flex: 1 }}
                                                    inputContainerStyle={{ paddingHorizontal: 8, height: 45 }}
                                                    onBlur={() => { formik?.setFieldTouched('restrictionValue', true);/*  formik?.setFieldValue('restrictionValue', formik?.values?.restrictionValue?.trim()) */ }}
                                                    errorMessage={formik?.touched?.restrictionValue && formik?.errors?.restrictionValue ? formik?.errors?.restrictionValue : undefined}
                                                    errorStyle={{ color: 'red', fontFamily: theme?.medium, fontSize: fontSize.errorFontSize }}
                                                />
                                            }
                                        </View>
                                        <View style={{ flexDirection: "row", flex: 1, gap: 25, marginTop: 5 }}>
                                            <ZenInput
                                                value={formik?.values?.TotalUsagelimits}
                                                onChangeText={(text) => formik.setFieldValue('TotalUsagelimits', text)}
                                                label={"Total Usage limits"}
                                                disabled={endDateExpired || !isDiscountAvailable || !isWrite ? true : false}
                                                labelStyle={theme?.automaticDiscountListStyle?.labelStyle}
                                                inputStyle={theme?.automaticDiscountListStyle?.inputStyle}
                                                type="outlined"
                                                containerStyle={{ flex: 1 }}
                                                inputContainerStyle={{ paddingHorizontal: 8, height: 45 }}
                                                onBlur={() => { formik?.setFieldTouched('TotalUsagelimits', true); formik?.setFieldValue('TotalUsagelimits', formik?.values?.TotalUsagelimits) }}
                                                rightIcon={
                                                    <ZenToolTip
                                                        height={50}
                                                        width={200}
                                                        backgroundColor={appColors?.lightBackgroundColor}
                                                        popoverStyle={{ elevation: 4 }}
                                                        content={<ZenText content='Number of times the discount is to be used' color={appColors.dark} size={fontSize.errorFontSize} />}
                                                        popover={<Pressable onPress={() => { }}>
                                                            <ZenIcon name="information" type="material-community" size={16} color={appColors?.primary} style={{ marginLeft: 5, marginTop: 7 }} />
                                                        </Pressable>}
                                                    />
                                                }
                                                errorMessage={formik?.touched?.TotalUsagelimits && formik?.errors?.TotalUsagelimits ? formik?.touched?.TotalUsagelimits && formik?.errors?.TotalUsagelimits : undefined}
                                                errorStyle={{ color: 'red', fontFamily: theme?.medium, fontSize: fontSize.errorFontSize }}
                                            />
                                            <ZenInput
                                                value={formik?.values?.Usagelimitpercustomer}
                                                onChangeText={(text) => formik.setFieldValue('Usagelimitpercustomer', text)}
                                                label={!isLandscape ? "Limits per customer" : "Usage limits per customer"}
                                                disabled={endDateExpired || !isDiscountAvailable || !isWrite ? true : false}
                                                labelStyle={theme?.automaticDiscountListStyle?.labelStyle}
                                                inputStyle={theme?.automaticDiscountListStyle?.inputStyle}
                                                type="outlined"
                                                keyboardType="numeric"
                                                containerStyle={{ flex: 1 }}
                                                inputContainerStyle={{ paddingHorizontal: 8, height: 45 }}
                                                onBlur={() => { formik?.setFieldTouched('Usagelimitpercustomer', true); formik?.setFieldValue('Usagelimitpercustomer', formik?.values?.Usagelimitpercustomer) }}
                                                errorMessage={formik?.touched?.Usagelimitpercustomer && formik?.errors?.Usagelimitpercustomer ? formik?.touched?.Usagelimitpercustomer && formik?.errors?.Usagelimitpercustomer : undefined}
                                                errorStyle={{ color: 'red', fontFamily: theme?.medium, fontSize: fontSize.errorFontSize }}
                                            />
                                        </View>
                                    </View>

                                    <View style={{ backgroundColor: theme?.light, marginHorizontal: 10, borderRadius: 10, paddingHorizontal: 10, }}>
                                        <ZenText content={"Discount Applies To"} style={theme?.automaticDiscountListStyle?.subHeading} />
                                        <View style={{ flexDirection: !isLandscape ? "column" : "row", flex: 1, gap: !isLandscape ? 10 : 25 }}>
                                            <ZenRadioButton
                                                initialSelected={formik?.values?.discountAppliesTo}
                                                options={appliesTo.map((opt: any) => ({
                                                    ...opt,
                                                    disabled: endDateExpired || !isDiscountAvailable || !isWrite
                                                }))}
                                                titleStyle={{ color: theme?.lightDark, fontSize: fontSize?.largerFontSize }}
                                                containerStyle={{ flexDirection: "column", flex: 1, justifyContent: "space-between", flexWrap: "wrap" }}
                                                onSelect={(value) => {
                                                    setIsOptionChanged(true)
                                                    formik.setFieldValue('discountAppliesTo', value);
                                                }}
                                            />
                                            {applicableDiscountArr.get(formik?.values?.discountAppliesTo)?.value?.length ?
                                                <View style={{ flexDirection: "column", flex: 1, marginBottom: 10 }} >
                                                    <ZenText content={`Choose ${applicableDiscountArr.get(formik?.values?.discountAppliesTo)?.name} *`} style={{ fontFamily: theme?.medium, fontSize: fontSize.tinyFontSize, color: theme?.grey }} />
                                                    <ZenDropdown
                                                        items={applicableDiscountArr.get(formik?.values?.discountAppliesTo)?.value!!}
                                                        open={specificOptionOpen}
                                                        setOpen={setSpecificOptionOpen}
                                                        value={formik?.values?.specific}
                                                        // multipleText={multipleCustomerGroup?.length > (isLandscape ? 60 : 22) ? multipleCustomerGroup.slice(0, isLandscape ? 60 : 22).concat('...').toString() : multipleCustomerGroup.toString()}
                                                        setValue={() => { }}
                                                        multipleText={getAllLabelValue(formik?.values?.specific, false)}
                                                        multiple={true}
                                                        searchable={true}
                                                        searchPlaceholder={`Search ${applicableDiscountArr.get(formik?.values?.discountAppliesTo)?.name}`}
                                                        maxHeight={140}
                                                        dropdownDirection='TOP'
                                                        disabled={endDateExpired || !isDiscountAvailable || !isWrite ? true : false}
                                                        labelStyle={{ fontSize: fontSize.tinyFontSize, color: endDateExpired || !isWrite ? theme.lightGrey : theme?.dark, fontFamily: theme?.medium, }}
                                                        placeholderStyle={{ color: theme?.grey, fontFamily: theme?.medium, fontSize: fontSize.tinyFontSize, }}
                                                        style={{ height: 46 }}
                                                        selectedItemLabelStyle={{ fontSize: fontSize.tinyFontSize, fontFamily: theme?.medium }}
                                                        containerStyle={{ marginTop: 5 }}
                                                        onClose={() => { formik.setFieldTouched('specific', true) }}
                                                        onSelectItem={(item) => {
                                                            formik.setFieldValue('specific', item?.map((val) => val?.id))
                                                        }}
                                                    />
                                                    {formik?.touched?.specific && formik?.errors?.specific &&
                                                        <ZenText content={formik?.errors?.specific} style={{ color: 'red', fontFamily: theme?.medium, fontSize: fontSize.errorFontSize }} />
                                                    }
                                                </View> : <></>}
                                        </View>
                                    </View>

                                    <View style={{ backgroundColor: theme?.light, marginHorizontal: 10, borderRadius: 10, paddingHorizontal: 10, }}>
                                        <ZenText content={"Schedule"} style={theme?.automaticDiscountListStyle?.subHeading} />
                                        <View style={{ flexDirection: "row", flex: 1, gap: 25 }}>
                                            <Pressable style={PayXGetFreeStyle.inputFlex} onPress={() => {
                                                if (formik?.values?.startDate != '' && (moment(formik?.values?.startDate).endOf('day').toDate() > moment(new Date()).endOf('day').toDate())) {
                                                    setDate(new Date(formik?.values?.startDate))
                                                }
                                                else {
                                                    setDate(new Date());
                                                }
                                                formik.setFieldTouched('startDate', true);
                                                setStartDateSelected(true)
                                                setShowDate(!showDate);
                                            }}>

                                                <ZenInput
                                                    value={formik?.values?.startDate != '' ? moment(new Date(formik?.values?.startDate))?.format('MM/DD/YYYY')?.toString() : undefined}
                                                    onChangeText={(text) => formik.setFieldValue('startDate', text)}
                                                    label={"Start date"}
                                                    placeholder='MM/DD/YYYY'
                                                    editable={false}
                                                    labelStyle={theme?.automaticDiscountListStyle?.labelStyle}
                                                    inputStyle={theme?.automaticDiscountListStyle?.inputStyle}
                                                    type="outlined"
                                                    containerStyle={{ flex: 1 }}
                                                    inputContainerStyle={{ paddingHorizontal: 8, height: 45 }}
                                                    rightIcon={<ZenIcon name="calendar" type='material-community' size={20} color={theme?.grey} disabled={!isDiscountAvailable}
                                                    />}
                                                    errorMessage={formik.touched.startDate && formik.errors.startDate ? formik.errors.startDate : undefined}
                                                    errorStyle={{ color: 'red', fontFamily: theme?.medium, fontSize: fontSize.errorFontSize }}
                                                />
                                            </Pressable>
                                            <Pressable style={PayXGetFreeStyle.inputFlex} onPress={() => {
                                                if (formik?.values?.endDate != '' && (moment(formik?.values?.endDate).endOf('day').toDate() > moment(new Date()).endOf('day').toDate())) {
                                                    setDate(new Date(formik?.values?.endDate));
                                                }
                                                else {
                                                    setDate(new Date())
                                                }
                                                formik.setFieldTouched('endDate', true)
                                                setStartDateSelected(false)
                                                setShowDate(!showDate)

                                            }} >

                                                <ZenInput
                                                    value={formik?.values?.endDate != '' ? moment(new Date(formik?.values?.endDate))?.format('MM/DD/YYYY')?.toString() : undefined}
                                                    onChangeText={(text) => formik.setFieldValue('endDate', text)}
                                                    label={"End date"}
                                                    placeholder='MM/DD/YYYY'
                                                    editable={false}
                                                    labelStyle={theme?.automaticDiscountListStyle?.labelStyle}
                                                    inputStyle={theme?.automaticDiscountListStyle?.inputStyle}
                                                    type="outlined"
                                                    containerStyle={{ flex: 1 }}
                                                    inputContainerStyle={{ paddingHorizontal: 8, height: 45 }}
                                                    rightIcon={<ZenIcon name="calendar" size={20} type='material-community' color={theme?.grey} disabled={!isDiscountAvailable}
                                                    />}
                                                    errorMessage={formik.touched.endDate && formik.errors.endDate ? formik.errors.endDate : undefined}
                                                    errorStyle={{ color: 'red', fontFamily: theme?.medium, fontSize: fontSize.errorFontSize }}
                                                />
                                            </Pressable>
                                        </View>
                                        {showDate &&
                                            <ZenDateTimePicker
                                                date={mydate}
                                                mode='date'
                                                open={showDate}
                                                onConfirm={(val) => { onDateConfirm(val); }}
                                                minimumDate={startDateSelected ? new Date(moment().format("YYYY-MM-DD")) : (formik.values?.startDate ? new Date(formik.values?.startDate) : new Date(moment().format("YYYY-MM-DD")))}
                                                maximumDate={startDateSelected && formik?.values?.endDate ? new Date(formik?.values?.endDate) : undefined}
                                                onCancel={() => { setShowDate(false) }}
                                            />}
                                    </View>

                                    <View style={{ backgroundColor: theme?.light, marginHorizontal: 10, borderRadius: 10, paddingHorizontal: 10, }}>
                                        <ZenText content={"Customer Eligibility"} style={theme?.automaticDiscountListStyle?.subHeading} />
                                        <View style={{ flexDirection: !isLandscape ? "column" : "row", flex: 1, gap: !isLandscape ? 10 : 25, marginBottom: 10 }}>
                                            <View style={{ flexDirection: "column", flex: eligibileCustomersArr.get(formik?.values?.customerEligibilityType)?.value?.length ? 0.5 : 0.49, marginRight: formik?.values?.customerEligibilityType ? 0 : 20 }} >
                                                <ZenDropdown
                                                    items={typesOfEligibility}
                                                    open={eligibilityOpen}
                                                    setOpen={setEligibilityOpen}
                                                    value={formik?.values?.customerEligibilityType}
                                                    setValue={() => { }}
                                                    title='Customer Eligibility Type'
                                                    multiple={false}
                                                    dropdownDirection='TOP'
                                                    disabled={endDateExpired || !isDiscountAvailable || !isWrite ? true : false}
                                                    titleStyle={{ fontFamily: theme?.medium, fontSize: fontSize.tinyFontSize, color: theme?.grey }}
                                                    labelStyle={{ fontSize: fontSize.tinyFontSize, color: endDateExpired || !isWrite ? theme.grey : theme?.dark, fontFamily: theme?.medium, }}
                                                    placeholderStyle={{ color: theme?.grey, fontFamily: theme?.medium, fontSize: fontSize.tinyFontSize, }}
                                                    style={{ height: 46 }}
                                                    selectedItemLabelStyle={{ fontSize: fontSize.tinyFontSize, fontFamily: theme?.medium }}
                                                    containerStyle={{ marginTop: 5 }}
                                                    onPress={() => { setCustomerGroupOpen(false), formik?.setFieldTouched('customerEligibilityType', true); }}
                                                    onSelectItem={(item) => {
                                                        setIsOptionChanged(true)
                                                        formik?.setFieldValue('customerEligibilityType', item?.value)
                                                    }}
                                                />
                                                {formik?.touched?.customerEligibilityType && formik?.errors?.customerEligibilityType ?
                                                    <ZenText content={formik?.errors?.customerEligibilityType} style={{ color: 'red', fontFamily: theme?.medium, fontSize: fontSize.errorFontSize }} />

                                                    : undefined}
                                            </View>
                                            {eligibileCustomersArr.get(formik?.values?.customerEligibilityType)?.value?.length ?
                                                <View style={{ flexDirection: "column", flex: 0.5 }} >
                                                    <ZenDropdown
                                                        items={eligibileCustomersArr.get(formik?.values?.customerEligibilityType)?.value!!}
                                                        open={customerGroupOpen}
                                                        setOpen={setCustomerGroupOpen}
                                                        value={formik?.values?.eligibility}
                                                        title={`Choose ${eligibileCustomersArr.get(formik?.values?.customerEligibilityType)?.name} *`}
                                                        // multipleText={multipleCustomerGroup?.length > (isLandscape ? 60 : 22) ? multipleCustomerGroup.slice(0, isLandscape ? 60 : 22).concat('...').toString() : multipleCustomerGroup.toString()}
                                                        setValue={() => { }}
                                                        multipleText={getAllLabelValue(formik?.values?.eligibility, true)}
                                                        multiple={true}
                                                        searchable={true}
                                                        searchPlaceholder={`Search ${eligibileCustomersArr.get(formik?.values?.customerEligibilityType)?.name}`}
                                                        maxHeight={140}
                                                        dropdownDirection='TOP'
                                                        disabled={endDateExpired || !isDiscountAvailable || !isWrite ? true : false}
                                                        titleStyle={{ fontFamily: theme?.medium, fontSize: fontSize.tinyFontSize, color: theme?.grey }}
                                                        labelStyle={{ fontSize: fontSize.tinyFontSize, color: endDateExpired || !isWrite ? theme?.grey : theme?.dark, fontFamily: theme?.medium, }}
                                                        placeholderStyle={{ color: theme?.grey, fontFamily: theme?.medium, fontSize: fontSize.tinyFontSize, }}
                                                        style={{ height: 46 }}
                                                        selectedItemLabelStyle={{ fontSize: fontSize.tinyFontSize, fontFamily: theme?.medium }}
                                                        containerStyle={{ marginTop: 5 }}
                                                        onClose={() => { formik.setFieldTouched('eligibility', true) }}
                                                        onSelectItem={(item) => {
                                                            formik.setFieldValue('eligibility', item?.map((val) => val?.id))
                                                        }}
                                                        onPress={() => { setEligibilityOpen(false) }}
                                                    />
                                                    {formik?.touched?.eligibility && formik?.errors?.eligibility ?
                                                        <ZenText content={formik?.errors?.eligibility} style={{ color: 'red', fontFamily: theme?.medium, fontSize: fontSize.errorFontSize }} />
                                                        : undefined}
                                                </View> : <></>}
                                        </View>

                                    </View>

                                </View>
                            </ScrollView>
                        }
                    </View>

                    <CustomModal transparent={true} visible={failedToLoadingProps} style={{ backfaceVisibility: 'hidden' }}>
                        <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', backgroundColor: theme?.transparentBackground }}>
                            <View style={{ width: width > 900 ? 600 : isLandscape ? 500 : 300, backgroundColor: theme?.light, borderRadius: 10 }}>
                                <View style={{ paddingHorizontal: 15, paddingVertical: 15, backgroundColor: theme?.lightBackgroundColor, borderTopRightRadius: 10, borderTopLeftRadius: 10 }}>
                                    <ZenText content="Confirmation" bold size={fontSize.largerFontSize} color={theme?.dark} />
                                </View>
                                <View style={{ paddingHorizontal: 20, paddingVertical: 10 }}>
                                    <ZenText content={failedProps?.content} color={theme?.dark} bold size={fontSize.mediumFontSize} style={[{ textAlign: 'justify', width: '80%' }]} />
                                    <View style={{ flexDirection: "row-reverse", justifyContent: "space-between", alignSelf: 'center', marginVertical: 10 }}>
                                        {failedProps?.button.map((item, index) => (
                                            <Pressable key={index}
                                                style={{ justifyContent: 'space-between', backgroundColor: theme?.light, alignItems: 'center', paddingVertical: 5, borderRadius: 10, borderWidth: 1.5, borderColor: theme?.lightGrey, paddingHorizontal: 20 }}
                                                onPress={() => confirmation(item)} >
                                                <ZenText size={fontSize.mediumFontSize} bold content={item?.name} color={'#800000'} style={{ textTransform: 'capitalize', paddingHorizontal: 10, textAlign: 'center', }} />
                                            </Pressable>
                                        ))
                                        }
                                    </View>
                                </View>
                            </View>
                        </View>
                    </CustomModal>
                    <Popover isVisible={expiredPopover} popoverStyle={{ width: width > 900 ? width / 2 : isLandscape ? 450 : 350, borderRadius: 10 }}>
                        <CommonDialogBox type='OTHER' dialog={expiredDialogProps} confirmation={confirmation} />
                    </Popover>
                    <Popover isVisible={warningPopover == 'leave'} popoverStyle={{ width: width > 900 ? width / 2 : isLandscape ? 450 : 350, borderRadius: 10 }}>
                        <CommonDialogBox type='OTHER' dialog={leaveDialogProps} confirmation={confirmation} />
                    </Popover>

                </KeyboardAvoidingView>
            )}
        </ThemeConsumer>
    )
}


export default AddEditAutomaticDiscount

